import {StyleSheet, TouchableOpacity, View} from 'react-native';
import {CustomText} from '../../../components';
import React from 'react';
import SVG from '../../../imports/svg';
import {Shadow} from 'react-native-shadow-2';
import {windowWidth} from '../../../constants';
import {useHistory} from '../../../imports/Router';

const Header = ({title}) => {
  const history = useHistory();

  const goBack = () => {
    history.replace('/main/map/drive');
  };

  return (
    <View style={styles.container}>
      <View/>
      <Shadow distance={5} startColor="rgba(0,0,0,0.1)">
        <TouchableOpacity onPress={goBack} style={styles.closeContainer}>
          <SVG name={'closeCircle'} width={23.9} height={23.9} />
        </TouchableOpacity>
      </Shadow>
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 40,
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    paddingHorizontal: 15,
    alignItems: 'center',
    marginTop: 12,
  },
  closeContainer: {
    flexDirection: 'row',
    width: 40,
    height: 40,
    padding: 8,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
